import type { FC } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { useExpertImageQuery } from 'hooks';


const ExpertImage: FC = () => {
  const expertImageData = useExpertImageQuery();
  const expertImage = getImage(expertImageData);

  if (!expertImage) {
    return null;
  }

  return <GatsbyImage image={expertImage} alt='Expert' style={{ borderRadius: '50%' }} />;
};

export default ExpertImage;
